"use strict";
import BtnClose from './../btn/btnclose';

class Youtube{
	constructor(){
		this.$Youtube = $('#Youtube');		
		this.btnClose = new BtnClose(this.$Youtube.find('.BtnClose'));
		this.player;
		
		this.initYoutube();
		
		this.$Youtube.find('.bg').on('click',()=>{
			this.close();
		})
		
		this.btnClose.on('click',()=>{
			this.close();
		});
	}
	
	initYoutube(){
		let tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
	
	initPlayer(youtubeid){
		this.$Youtube.find('.youtube').append('<div id="YoutubeBoby"></div>');
		this.player = new YT.Player('YoutubeBoby', {
			height: '100%',
			width: '100%',
			videoId: youtubeid,
			playerVars: {
				wmode : 'transparent',
		        autohide: 1,
		        rel: 0,
		        showinfo: 0,
		        autoplay:1
		    },
			events: {
				'onReady': function(e) {
					//self._onPlayerReady.apply(self, arguments)
				},
				'onStateChange': function(e) {
					if(e.data == 0 || e.data == 1 || e.data == 2 || e.data == 3){
						//Main.isYoutubePlay = true;
					} else {
						//Main.isYoutubePlay = false;
					}
					//self._onPlayerStateChange.apply(self, arguments)
				}
			}
        });
	}
	
	open(youtubeid){
		this.$Youtube.velocity('stop').removeAttr('style').show();
		this.$Youtube.find('.youtube').velocity('stop').removeAttr('style').css({visibility:'hidden'});
		this.$Youtube.find('.bg').velocity('stop').removeAttr('style').css({visibility:'hidden'});
		let sumTime = 0;

		this.$Youtube.find('.bg').velocity('stop')
			.velocity({opacity:[1,0]},{duration:400,easing:'swing',visibility:'visible',delay:sumTime
				,complete:()=>{
					this.$Youtube.find('.youtube').velocity({opacity:[1,0]},{duration:200,easing:'swing',visibility:'visible',delay:sumTime
						,complete:()=>{
							this.initPlayer(youtubeid);
						}
					});
					
				}
			});
			
		sumTime += 500;
		this.btnClose.open(sumTime);
		
	}
	
	close(){
		this.player.pauseVideo();
		this.$Youtube.find('.youtube').velocity({opacity:0},{duration:300,easing:'swing'});
		this.$Youtube.velocity('stop').velocity({opacity:0},{duration:300,easing:'swing',display:'none',delay:300
			,complete:()=>{
				this.player.stopVideo();
				this.player.destroy();
				this.$Youtube.find('.youtube').empty();
			}
		});
	}
	
}

export default new Youtube();


// WEBPACK FOOTER //
// ./js/parts/youtube.js